<div class="test" [class.disabled]="isLoading">
    <div class="absolute">
        <div class="container  ">
            <div class="row position-relative">
                <div class="col-md-6 mx-auto text-center">
                    <!-- <img class="imgformat" src="assets/img/Carbontek.png" style="justify-items: center" /> -->
                    <img class="imgformat" [src]="logoUrl" style="justify-items: center" />
                </div>
                <i class="fa-solid fa-xmark close-btn" routerLink="/login">

                </i>
            </div>
            <div class="row">
                <div class="col pt-3">
                    <h1 class="text-center">You forgot your password? Here you can easily retrieve a new
                        password.</h1>
                </div>
            </div>


            <div class="row pr-3">
                <div class="col pt-3">
                    <form #fForm="ngForm" (ngSubmit)="onSubmit(fForm)">
                        <div class="form-group ">
                            <label>Registered Email</label>
                            <input type="text" name="useremail" #useremail="ngModel" [(ngModel)]="forgotData.email" placeholder="Enter your registered email"
                                class="form-control text-white" style="background-color: transparent" required email />
                                <p *ngIf="useremail.invalid && useremail.touched" class="text-danger mt-1">Email is required</p>
                            

                        </div>

                        <div class="row">
                            <div class="col-12 pt-5 d-flex justify-content-center">
                                <button class="text-white btn" type="submit" [disabled]="!fForm.valid">
                                    Request new password
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>